/**
 * @generated SignedSource<<cff1ffc744e4a2950d8a1f273c77168a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useMeetingRecordingWebsocket_meetingRecording$data = {
  readonly id: string;
  readonly isGeneratingRecapTemplate: boolean;
  readonly redactionIsInProgress: boolean;
  readonly regenerationForLanguageIsInProgress: boolean;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"DislikeModal_meetingRecording">;
  readonly " $fragmentType": "useMeetingRecordingWebsocket_meetingRecording";
};
export type useMeetingRecordingWebsocket_meetingRecording$key = {
  readonly " $data"?: useMeetingRecordingWebsocket_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMeetingRecordingWebsocket_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMeetingRecordingWebsocket_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redactionIsInProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isGeneratingRecapTemplate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regenerationForLanguageIsInProgress",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DislikeModal_meetingRecording"
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "c695bee881545244bd928b39d5254725";

export default node;
